import React from 'react';
import PropTypes from 'prop-types';

const StudentLoans = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 114 114"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity=".2"
      d="M57 114c31.48 0 57-25.52 57-57S88.48 0 57 0 0 25.52 0 57s25.52 57 57 57z"
      fill="#B1E0E2"
    />
    <path
      d="M41.93 73.882a58.85 58.85 0 0015.283 1.78c13.822 0 24.937-4.381 24.937-9.048V53.86M32.063 52.903v13.965c0 1.817 1.603 3.563 4.31 4.952M55.752 61.311L19.913 47.916a1.319 1.319 0 010-2.53L55.86 34.308c.464-.143.96-.143 1.425 0l36.765 12.47a1.354 1.354 0 010 2.564L59.101 61.382a5.023 5.023 0 01-3.349-.07v0z"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.587 48.225c1.437-.01 2.596-.721 2.589-1.587-.007-.866-1.176-1.559-2.613-1.548-1.436.011-2.595.722-2.588 1.588.007.866 1.176 1.558 2.612 1.547zM54.257 48.232l-15.675 6.805.25 24.438"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.84 84.391a2.779 2.779 0 003.027 2.387 2.743 2.743 0 002.993-2.423 2.708 2.708 0 00-3.028-2.422 2.496 2.496 0 01-3.086-2.423 2.494 2.494 0 013.086-2.422 2.778 2.778 0 013.028 2.387M38.795 75.347l.107 13.288"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

StudentLoans.defaultProps = {
  className: '',
};

StudentLoans.propTypes = {
  className: PropTypes.string,
};

export default StudentLoans;
